import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";

import { SubscriptionCancellation } from "../components/subscription/SubscriptionCancellation";
import { usePageTitle } from "../utils/usePageTitle";

import "../components/subscription/SubscriptionManageCheckout.css";
import "./SubscriptionUpdatePage.css";

export function SubscriptionCancelPage() {
  const { t } = useTranslation();
  const title = t("subscription.cancelSubscription");
  usePageTitle(title);

  return (
    <div className="page subscription-update-page">
      <Breadcrumb
        className="subscription-update-page__breadcrumb"
        items={[
          { title: <Link to="/subscription">{t("subscription.title")}</Link> },
          { title },
        ]}
      />
      <h1>{title}</h1>
      <SubscriptionCancellation />
    </div>
  );
}
